import { useMemo } from 'react';

const MOBILE_REGEX =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

const CT47_REGEX = /CT47|Honeywell/i;

type PlatformPayload = {
  isSSR: boolean;
  isMobile: boolean;
  isDesktop: boolean;
  isMac: boolean;
  isCT47: boolean;
};

export const usePlatform = (): PlatformPayload => {
  const platforms = useMemo(() => {
    if (navigator == null) {
      return {
        isSSR: true,
        isMobile: false,
        isDesktop: false,
        isMac: false,
        isCT47: false
      };
    }
    const isMobile = navigator.userAgent.match(MOBILE_REGEX) != null;
    const isMac = navigator.userAgent.toUpperCase().match(/MAC/) != null;
    const isCT47 = navigator.userAgent.match(CT47_REGEX) != null;

    return {
      isSSR: false,
      isMobile,
      isDesktop: !isMobile,
      isMac,
      isCT47
    };
  }, []);

  return platforms;
};
